export const TYPE_RETIREMENT = {
	farmacia: 'Retiro en farmacia',
	domicilio: 'Envío a domicilio',
};
